export default "__VITE_ASSET__a18439f6__"